import config from "@/config";
import http from "@/utils/request";

export default {
	plugin: {
		//插件列表（GET ?app=bwmall，返回插件卡片数据，行含buy已购标识/info.url插件管理地址/label角标）
		index: {
			url: `${config.API_URL}/manage/member/plugin/core/index`,
			name: "插件列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//购买插件（POST：id/paypwd六位支付密码，余额扣款，仅顶级管理员）
		buy: {
			url: `${config.API_URL}/manage/member/plugin/buy`,
			name: "购买插件",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	template: {
		//订阅消息模板列表（GET ?miniapp_id，buildTableParames筛选，行含type0小程序/1公众号）
		index: {
			url: `${config.API_URL}/manage/member/wechat/message/template/index`,
			name: "订阅消息模板列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//新增（POST：member_miniapp_id/type/name/key/template_id/content/status；同type+key不可重复）
		add: {
			url: `${config.API_URL}/manage/member/wechat/message/template/add`,
			name: "新增订阅消息模板",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//编辑-取详情（GET ?id=，直接返回行数据）
		editGet: {
			url: `${config.API_URL}/manage/member/wechat/message/template/edit`,
			name: "订阅消息模板详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//编辑-保存（POST，同add字段+id）
		editPost: {
			url: `${config.API_URL}/manage/member/wechat/message/template/edit`,
			name: "编辑订阅消息模板",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//属性修改（POST：id/field/value）
		modify: {
			url: `${config.API_URL}/manage/member/wechat/message/template/modify`,
			name: "订阅消息模板属性修改",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//一键同步（POST：从微信公共模板库自动添加模板并回填模板ID与字段结构，返回逐项明细）
		sync: {
			url: `${config.API_URL}/manage/member/wechat/message/template/sync`,
			name: "一键同步订阅消息模板",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除/批量删除（POST：id，批量传数组）
		del: {
			url: `${config.API_URL}/manage/member/wechat/message/template/del`,
			name: "删除订阅消息模板",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	messageLog: {
		//订阅消息发送记录（GET ?miniapp_id，行含template{name}嵌套，status 1成功/0失败带fail_msg；仅删除无编辑）
		index: {
			url: `${config.API_URL}/manage/member/wechat/message/messageLog/index`,
			name: "订阅消息发送记录",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//删除（POST：id）
		del: {
			url: `${config.API_URL}/manage/member/wechat/message/messageLog/del`,
			name: "删除发送记录",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	keyword: {
		//关注回复配置-取数据（GET ?miniapp_id=，返回{msgTypes消息类型,subscribeData当前配置}）
		subscribeGet: {
			url: `${config.API_URL}/manage/member.wechatKeyword/subscribe`,
			name: "关注回复配置详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//关注回复配置-保存（POST：keys固定subscribe/type消息类型/对应素材字段/status/id；走addKeys逻辑）
		subscribePost: {
			url: `${config.API_URL}/manage/member.wechatKeyword/subscribe`,
			name: "保存关注回复配置",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	keywordRule: {
		//回复规则列表（GET ?miniapp_id，排除subscribe，行含keys/type/各素材字段/status/create_at）
		index: {
			url: `${config.API_URL}/manage/member.wechatKeyword/index`,
			name: "回复规则列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//编辑-取详情（GET ?id=，直接返回行数据）
		editGet: {
			url: `${config.API_URL}/manage/member.wechatKeyword/edit`,
			name: "回复规则详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//编辑-保存（POST：id+keys/type/素材字段/status）
		editPost: {
			url: `${config.API_URL}/manage/member.wechatKeyword/edit`,
			name: "编辑回复规则",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//新增（POST：keys/type/素材字段/status；同租户keys唯一，走addKeys逻辑）
		addKeys: {
			url: `${config.API_URL}/manage/member.wechatKeyword/addKeys`,
			name: "新增回复规则",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除（POST：id）
		del: {
			url: `${config.API_URL}/manage/member.wechatKeyword/del`,
			name: "删除回复规则",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//属性修改（POST：id/field/value）
		modify: {
			url: `${config.API_URL}/manage/member.wechatKeyword/modify`,
			name: "回复规则属性修改",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	officialMenu: {
		//公众号菜单列表（GET ?miniapp_id，平铺两级树，行含level/parent_id/types/name/sort/url/key/pagepath/appid）
		index: {
			url: `${config.API_URL}/manage/member.official/index`,
			name: "公众号菜单列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//新增（POST：parent_id/name/types/对应字段/sort；一级最多3个≤4字，二级最多5个≤7字）
		add: {
			url: `${config.API_URL}/manage/member.official/add`,
			name: "新增公众号菜单",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//编辑-取详情（GET ?id=）
		editGet: {
			url: `${config.API_URL}/manage/member.official/edit`,
			name: "公众号菜单详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//编辑-保存（POST，同add字段+id）
		editPost: {
			url: `${config.API_URL}/manage/member.official/edit`,
			name: "编辑公众号菜单",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除（POST：ids；有子菜单时后端拦截）
		del: {
			url: `${config.API_URL}/manage/member.official/del`,
			name: "删除公众号菜单",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//排序（POST：id/sort）
		menuSort: {
			url: `${config.API_URL}/manage/member.official/menuSort`,
			name: "公众号菜单排序",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//同步到微信公众号（POST，需已授权公众号）
		sync: {
			url: `${config.API_URL}/manage/member.official/sync`,
			name: "同步公众号菜单",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//微信远程素材列表（GET ?page&limit&type=news，需公众号授权；layui格式返回 code:0/count/data）
		materialList: {
			url: `${config.API_URL}/manage/member.official/materialList`,
			name: "微信远程素材列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		}
	},
	material: {
		//图文列表（GET ?miniapp_id&page&limit，返回{page:{limit,total,pages,current},list:[{id,articles:[{title,local_url封面,author,digest,content,content_source_url}]}]}）
		list: {
			url: `${config.API_URL}/manage/member.wechatKeyword/materialList`,
			name: "微信图文列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//图文详情（GET ?output=json&id=，返回{id,articles:[...]}）
		addGet: {
			url: `${config.API_URL}/manage/member.wechatKeyword/addMaterial`,
			name: "微信图文详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//图文保存（POST：id可选+data文章数组[{title,local_url,author,digest,content,content_source_url,show_cover_pic}]）
		addPost: {
			url: `${config.API_URL}/manage/member.wechatKeyword/addMaterial`,
			name: "保存微信图文",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除图文（POST：id）
		del: {
			url: `${config.API_URL}/manage/member.wechatKeyword/removeMaterial`,
			name: "删除微信图文",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	//应用主页（member.setting）：回显用index的ajax分支，保存走edit/wechat/alipay/tt_wechat
	setting: {
		//应用主页信息（GET ?miniapp_id=，需带ajax头；返回{view{audit,update},date,web_name,navbar_url,wechat,alipay,tt_wechat}）
		index: {
			url: `${config.API_URL}/manage/member.setting/index`,
			name: "应用主页信息",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//应用配置保存（POST：appname/miniapp_appid/miniapp_secret/mp_appid/mp_secret/mp_token/mp_aes_key/tt_appid/tt_secret）
		edit: {
			url: `${config.API_URL}/manage/member.setting/edit`,
			name: "保存应用配置",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//微信支付配置（POST：is_tpa/tpa_appid/tpa_mch_id/mch_id/key/cert_path/key_path）
		wechat: {
			url: `${config.API_URL}/manage/member.setting/wechat`,
			name: "保存微信支付配置",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//支付宝配置（POST：app_id/public_key/alipay_cert_path/alipay_public_path）
		alipay: {
			url: `${config.API_URL}/manage/member.setting/alipay`,
			name: "保存支付宝配置",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//头条微信支付配置（POST：mp_toutiao_token/mp_toutiao_salt）
		ttWechat: {
			url: `${config.API_URL}/manage/member.setting/tt_wechat`,
			name: "保存头条微信支付配置",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	//我的应用列表（GET 分页；行含appname/9配置字段/expire_time，嵌套miniapp{title,types,logo_image,describe,is_openapp,is_wechat_pay...}）
	myApps: {
		url: `${config.API_URL}/manage/member_miniapp_my/index`,
		name: "我的应用列表",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	},
	//小程序开放平台上架操作（member.Miniapp；均带miniapp_id，真实操作微信平台，前端需二次确认）
	miniapp: {
		//绑定业务域名
		setDomain: {
			url: `${config.API_URL}/manage/member/setDomain`,
			name: "绑定业务域名",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//上传/升级小程序代码
		upCode: {
			url: `${config.API_URL}/manage/member/upCode`,
			name: "上传小程序代码",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//提交审核
		submitAudit: {
			url: `${config.API_URL}/manage/member/submitAudit`,
			name: "提交审核",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//发布小程序
		publishCode: {
			url: `${config.API_URL}/manage/member/publishCode`,
			name: "发布小程序",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//查询审核状态
		getAuditStatus: {
			url: `${config.API_URL}/manage/member/getAuditStatus`,
			name: "查询审核状态",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//获取体验码
		getQrCode: {
			url: `${config.API_URL}/manage/member/getQrCode`,
			name: "获取体验码",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//强制撤销审核
		resetAudit: {
			url: `${config.API_URL}/manage/member/resetAudit`,
			name: "强制撤销审核",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	// ==================== 定时任务（后端 manage.TimerTask 控制器） ====================
	timerTask: {
		//分页列表（GET ?page&limit，返回 {total,list}；行含 last_run_time_cn/next_run_time_cn）
		list: {
			url: `${config.API_URL}/manage/timerTask/list`,
			name: "定时任务列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//详情（GET ?id=，编辑回显，custom_code 为可编辑代码文本）
		info: {
			url: `${config.API_URL}/manage/timerTask/info`,
			name: "定时任务详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//保存（POST：id/mark/type/month/week/day/hour/minute/second/is_open/custom_code）
		save: {
			url: `${config.API_URL}/manage/timerTask/save`,
			name: "保存定时任务",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除（POST：id，软删除）
		delete: {
			url: `${config.API_URL}/manage/timerTask/delete`,
			name: "删除定时任务",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//启停（POST：id/is_open 0|1，热生效免重启）
		status: {
			url: `${config.API_URL}/manage/timerTask/status`,
			name: "定时任务启停",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	// ==================== 自定义事件（后端 manage.CustomEvent 控制器） ====================
	customEvent: {
		//分页列表（GET ?page&limit，返回 {total,list}；行含 mark_name 场景中文名）
		list: {
			url: `${config.API_URL}/manage/customEvent/list`,
			name: "自定义事件列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//场景清单（GET，返回 [{value,label,data}]，data 为可用变量文本）
		mark: {
			url: `${config.API_URL}/manage/customEvent/mark`,
			name: "自定义事件场景清单",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//详情（GET ?id=，编辑回显，custom_code 已补回 <?php 头）
		info: {
			url: `${config.API_URL}/manage/customEvent/info`,
			name: "自定义事件详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//保存（POST：id/name/mark/content/custom_code/password/is_open；仅调试环境+超管+开发密码）
		save: {
			url: `${config.API_URL}/manage/customEvent/save`,
			name: "保存自定义事件",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除（POST：id，软删除）
		delete: {
			url: `${config.API_URL}/manage/customEvent/delete`,
			name: "删除自定义事件",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//启停（POST：id/is_open 0|1，热生效免重启）
		status: {
			url: `${config.API_URL}/manage/customEvent/status`,
			name: "自定义事件启停",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	// ==================== 数据库管理 ====================
	database: {
		tables: {
			url: `${config.API_URL}/manage/database/tables`,
			name: "数据表列表",
			get: async function(data = {}) { return await http.get(this.url, data); }
		},
		columns: {
			url: `${config.API_URL}/manage/database/columns`,
			name: "数据表字段",
			get: async function(data = {}) { return await http.get(this.url, data); }
		},
		backup: {
			url: `${config.API_URL}/manage/database/backup`,
			name: "创建数据库备份",
			post: async function(data = {}) { return await http.post(this.url, data); }
		},
		optimize: {
			url: `${config.API_URL}/manage/database/optimize`,
			name: "优化数据表",
			post: async function(data = {}) { return await http.post(this.url, data); }
		},
		repair: {
			url: `${config.API_URL}/manage/database/repair`,
			name: "修复数据表",
			post: async function(data = {}) { return await http.post(this.url, data); }
		},
		files: {
			url: `${config.API_URL}/manage/database/files`,
			name: "备份文件列表",
			get: async function(data = {}) { return await http.get(this.url, data); }
		},
		import: {
			url: `${config.API_URL}/manage/database/import`,
			name: "恢复数据库备份",
			post: async function(data = {}) { return await http.post(this.url, data); }
		},
		remove: {
			url: `${config.API_URL}/manage/database/file`,
			name: "删除备份文件",
			delete: async function(data = {}) { return await http.delete(this.url, data); }
		},
		download: {
			url: `${config.API_URL}/manage/database/download`,
			name: "下载备份文件",
			get: async function(data = {}, requestConfig = {}) { return await http.get(this.url, data, requestConfig); }
		},
		mark: {
			url: `${config.API_URL}/manage/database/mark`,
			name: "保存数据库备注",
			post: async function(data = {}) { return await http.post(this.url, data); }
		}
	},
	// ==================== 文件管理（后端 manage.SystemFile 控制器） ====================
	systemFile: {
		//二次登录（POST：password=.env FILE_PASSWORD，返回 {token:fileToken,expires_time}）
		login: {
			url: `${config.API_URL}/manage/systemFile/login`,
			name: "文件管理登录",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//打开目录（GET ?dir&filedir&superior&fileToken，返回 {dir,list,breadcrumb}）
		opendir: {
			url: `${config.API_URL}/manage/systemFile/opendir`,
			name: "打开目录",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//读取文件（GET ?filepath&fileToken，返回 {content,mode,filepath,encoding}）
		openfile: {
			url: `${config.API_URL}/manage/systemFile/openfile`,
			name: "读取文件",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//保存文件（POST：filepath/comment）
		savefile: {
			url: `${config.API_URL}/manage/systemFile/savefile`,
			name: "保存文件",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//新建文件夹（POST：path/name）
		createFolder: {
			url: `${config.API_URL}/manage/systemFile/createFolder`,
			name: "新建文件夹",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//新建文件（POST：path/name）
		createFile: {
			url: `${config.API_URL}/manage/systemFile/createFile`,
			name: "新建文件",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除（POST：path，递归删除；项目根与关键目录受保护）
		delete: {
			url: `${config.API_URL}/manage/systemFile/delete`,
			name: "删除文件",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//重命名（POST：oldname/newname）
		rename: {
			url: `${config.API_URL}/manage/systemFile/rename`,
			name: "重命名",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//复制目录（POST：surDir/toDir）
		copyFolder: {
			url: `${config.API_URL}/manage/systemFile/copyFolder`,
			name: "复制目录",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//读取备注（GET ?path&fileToken，返回 {full_path,mark}）
		mark: {
			url: `${config.API_URL}/manage/systemFile/mark`,
			name: "读取备注",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//保存备注（POST：full_path/mark）
		markSave: {
			url: `${config.API_URL}/manage/systemFile/markSave`,
			name: "保存备注",
			post: async function(data={}) {
				return await http.post(this.url, data);
			}
		}
	},
	// APP版本管理（/manage/appVersion/*，对应后端 manage.AppVersion 控制器）
	appVersion: {
		//分页列表（GET ?page&limit&platform，返回 {total,list}；行含 platform_cn/add_time_cn）
		list: {
			url: `${config.API_URL}/manage/appVersion/list`,
			name: "APP版本列表",
			get: async function(data = {}) {
				return await http.get(this.url, data);
			}
		},
		//发布/编辑版本（POST：id 0=新增/version/platform/info/url/is_force/is_new）
		save: {
			url: `${config.API_URL}/manage/appVersion/save`,
			name: "保存APP版本",
			post: async function(data = {}) {
				return await http.post(this.url, data);
			}
		},
		//删除版本（POST：id，软删除）
		delete: {
			url: `${config.API_URL}/manage/appVersion/delete`,
			name: "删除APP版本",
			post: async function(data = {}) {
				return await http.post(this.url, data);
			}
		}
	},
	// APP配置（/manage/app/base，对应后端 manage.AppConfig 控制器，mn_sys_config app 组 wechat 行）
	appConfig: {
		//微信开放平台移动应用凭证：GET -> {wechat_app_appid, wechat_app_appsecret}；POST 保存
		base: {
			url: `${config.API_URL}/manage/app/base`,
			name: "APP配置",
			get: async function() {
				return await http.get(this.url);
			},
			post: async function(data) {
				return await http.post(this.url, data);
			}
		}
	},
	// 城市数据（/manage/city/*，对应后端 manage.City 控制器，mn_sys_city 省市区三级）
	city: {
		//列表（GET：parent_id 父级city_id默认0，懒加载树逐级取数；传 name 时全局平铺搜索；level 级别筛选）
		index: {
			url: `${config.API_URL}/manage/city/index`,
			name: "城市列表",
			get: async function(data = {}) {
				return await http.get(this.url, data);
			}
		},
		//新增（POST：name 必填/parent_id 父级city_id 0=省级/area_code/lng/lat/is_show）
		add: {
			url: `${config.API_URL}/manage/city/add`,
			name: "新增城市",
			post: async function(data = {}) {
				return await http.post(this.url, data);
			}
		},
		//编辑-取详情（GET ?id=，直接返回行数据）
		editGet: {
			url: `${config.API_URL}/manage/city/edit`,
			name: "城市详情",
			get: async function(data = {}) {
				return await http.get(this.url, data);
			}
		},
		//编辑-保存（POST：id/name/area_code/lng/lat/is_show）
		editPost: {
			url: `${config.API_URL}/manage/city/edit`,
			name: "编辑城市",
			post: async function(data = {}) {
				return await http.post(this.url, data);
			}
		},
		//属性修改（POST：id/field/value，field 白名单 is_show）
		modify: {
			url: `${config.API_URL}/manage/city/modify`,
			name: "城市属性修改",
			post: async function(data = {}) {
				return await http.post(this.url, data);
			}
		},
		//删除（POST：id 支持数组批量，递归删除所有下级）
		del: {
			url: `${config.API_URL}/manage/city/del`,
			name: "删除城市",
			post: async function(data = {}) {
				return await http.post(this.url, data);
			}
		},
		//刷新城市数据缓存（city_data_tree）
		refreshCache: {
			url: `${config.API_URL}/manage/city/refreshCache`,
			name: "刷新城市缓存",
			post: async function() {
				return await http.post(this.url);
			}
		}
	}
}
